import './index.scss';

import imgcredito3 from '../../../../../assets/images/para-sua-empresa/img-credito/img-credito3@2x.png';

export const CE = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> CE - Cédula de crédito ao exportador </h1>

                <p>
                    Uma Cédula de Crédito à Exportação é um título de crédito
                    representativo de promessa de pagamento, emitido por um exportador
                    (sacador) contra um importador (sacado) no exterior, e que pode ser
                    negociado junto a instituições financeiras. Ela comprova a existência de
                    uma dívida do importador para com o exportador decorrente de uma
                    operação de exportação de bens ou serviços.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Título Executivo Extrajudicial: </span>
                    A Cédula de Crédito à Exportação tem
                    força de título executivo extrajudicial, o que facilita o processo de
                    cobrança em caso de inadimplência do importador.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Negociabilidade: </span>
                    Pode ser negociada (descontada ou vendida) pelo
                    exportador junto a bancos ou outras instituições financeiras, permitindo-
                    lhe antecipar o recebimento dos recursos da exportação. Isso
                    proporciona liquidez ao exportador.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Garantia: </span>
                    A Cédula de Crédito à Exportação pode ser garantida por meio
                    de seguro de crédito à exportação, mitigando o risco de inadimplência
                    do importador.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>  Moeda: </span>
                    Pode ser emitida em diversas moedas, geralmente na moeda da
                    transação comercial.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Prazo: </span>
                    Possui um prazo de vencimento definido, que pode variar de
                    acordo com as condições negociadas entre exportador e importador.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Partes Envolvidas: </span>
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Sacador (Exportador): </span>
                    Quem emite a Cédula de Crédito à Exportação.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Sacador (Importador): </span>
                    Quem deve efetuar o pagamento da Cédula.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Beneficiário: </span>
                    A pessoa ou instituição que receberá o pagamento da
                    Cédula. Pode ser o próprio exportador ou uma instituição financeira que
                    a tenha negociado.
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgcredito3} src={imgcredito3} />
                <div>
                    <h1> Vantagens </h1>

                    <p style={{ marginTop: '20px' }}>
                        <span style={{ fontWeight: 'bold' }}> Para o Exportador </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Antecipação de Recebíveis: </span>
                        Permite ao exportador
                        receber o valor da exportação antes do vencimento,
                        melhorando seu fluxo de caixa.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Transferência de Risco: </span>
                        Ao negociar a Cédula de Crédito à
                        Exportação com uma instituição financeira, o exportador
                        transfere a ela o risco de inadimplência do importador.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Acesso a Crédito: </span>
                        Facilita o acesso a outras linhas de
                        crédito, utilizando a Cédula como garantia.
                    </p>

                    <p style={{ marginTop: '20px' }}>
                        <span style={{ fontWeight: 'bold' }}>Para o Importador </span>
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Financiamento da Importação: </span>
                        Permite ao importador
                        financiar a compra de bens ou serviços do exterior, com
                        prazos de pagamento mais longos.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Flexibilidade: </span>
                        Oferece flexibilidade nas negociações com o
                        exportador, em relação ao prazo e às condições de
                        pagamento.
                    </p>

                    <div className='buttons-style inv' style={{marginTop:"10px"}}>
                    <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                </div>
                </div>
            </div>
        </div>

    )
}

